import React, { useEffect, useState } from "react";
import configData from "../config.json";
import { useNavigate, useParams } from "react-router-dom";
import { Button, CircularProgress } from "@mui/material";
import ErrorDialogMessage from "../components/missing_report_components/ErrorDialogMessage";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import MissingReportHeader from "../components/missing_report_components/MissingReportHeader";
import MissingReportSingleDevice from "../components/missing_report_components/MissingReportSingleDevice";
//toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getToken } from "../utils/auth"

function MissingDevicesReport() {
  const params = useParams();
  const navigate = useNavigate();
  const [missingDevicesList, setMissingDevicesList] = useState(null);
  const [missingDevicesError, setMissingDevicesError] = useState(null);
  const [missingDevicesLoading, setMissingDevicesLoading] = useState(false);
  const notify = (message, style) => {
    if (style === "success") {
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };
  const getMissingDevicesRequest = () => {
    setMissingDevicesError(null);
    setMissingDevicesLoading(true);
    const token = getToken()

    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };
    fetch(
      `${configData.SERVER_URL}/Missing-Devices-Report/${params.retailer}/${params.store}`,
      { headers }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        console.log(data);
        setMissingDevicesList(data);
        setMissingDevicesLoading(false);
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          notify(error, "error");
          setMissingDevicesError(error);
          setMissingDevicesLoading(false);
        }
      });
  };
  useEffect(() => {
    getMissingDevicesRequest();
  }, []);
  const handleNetworkUpdateClick = () => {
    setMissingDevicesLoading(true);
    const token = getToken()

    let newBody = {
      devices: missingDevicesList,
    };
    fetch(
      `${configData.SERVER_URL}/Missing-Devices-Report/${params.retailer}/${params.store}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(newBody),
      }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setMissingDevicesList(data);
        setMissingDevicesLoading(false);
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            setMissingDevicesLoading(false);
            notify(error, "error");
          }
        }
      });
  };
  return (
    <>
      {missingDevicesLoading === true ? (
        <div className="container-fluid" style={{ textAlign: "center" }}>
          <CircularProgress size={72} />
        </div>
      ) : missingDevicesError ? (
        <div className="container-fluid" style={{ textAlign: "center" }}>
          <ErrorDialogMessage
            errorMessage={
              "The request is limted to once every 30 seconds, please try again later"
            }
            onClickFunction={getMissingDevicesRequest}
          />
        </div>
      ) : (
        missingDevicesList && (
          <div className="container-fluid">
            <MissingReportHeader
              devices={missingDevicesList}
              getMissingDevicesRequest={getMissingDevicesRequest}
              handleNetworkUpdateClick={handleNetworkUpdateClick}
            />
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <strong>Serial Number</strong>
                    </TableCell>
                    <TableCell align="center">
                      <strong>Networks</strong>
                    </TableCell>
                    <TableCell align="center">
                      <strong>Swan Song</strong>
                    </TableCell>
                    <TableCell align="center">
                      <strong>Beacon</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {missingDevicesList.map((device) => (
                    <MissingReportSingleDevice device={device} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )
      )}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default MissingDevicesReport;
